// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/aggregate/v1/timeseries.proto (package chalk.aggregate.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Duration } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/aggregate/v1/timeseries.proto.
 */
export const file_chalk_aggregate_v1_timeseries: GenFile = /*@__PURE__*/
  fileDesc("CiNjaGFsay9hZ2dyZWdhdGUvdjEvdGltZXNlcmllcy5wcm90bxISY2hhbGsuYWdncmVnYXRlLnYxIugBChdBZ2dyZWdhdGVUaW1lU2VyaWVzUnVsZRITCgthZ2dyZWdhdGlvbhgBIAEoCRIyCg9idWNrZXRfZHVyYXRpb24YAiABKAsyGS5nb29nbGUucHJvdG9idWYuRHVyYXRpb24SGgoSZGVwZW5kZW50X2ZlYXR1cmVzGAMgAygJEiwKCXJldGVudGlvbhgEIAEoCzIZLmdvb2dsZS5wcm90b2J1Zi5EdXJhdGlvbhIYChBkYXRldGltZV9mZWF0dXJlGAUgASgJEiAKGG1hdGVyaWFsaXphdGlvbl9rZXlfaGFzaBgGIAEoCSKaAgoTQWdncmVnYXRlVGltZVNlcmllcxIRCgluYW1lc3BhY2UYASABKAkSGAoMYWdncmVnYXRlX29uGAIgASgJQgIYARIQCghncm91cF9ieRgDIAMoCRI6CgVydWxlcxgFIAMoCzIrLmNoYWxrLmFnZ3JlZ2F0ZS52MS5BZ2dyZWdhdGVUaW1lU2VyaWVzUnVsZRIbChNmaWx0ZXJzX2Rlc2NyaXB0aW9uGAYgASgJEhYKDmJ1Y2tldF9mZWF0dXJlGAcgASgJEh0KFWFnZ3JlZ2F0ZV9vbl9mZWF0dXJlcxgIIAMoCRIXCg9maWx0ZXJfZmVhdHVyZXMYCSADKAkSGwoTcHJvamVjdGlvbl9mZWF0dXJlcxgKIAMoCUIaWhhhZ2dyZWdhdGUvdjE7YWdncmVnYXRldjFiBnByb3RvMw", [file_google_protobuf_duration]);

/**
 * @generated from message chalk.aggregate.v1.AggregateTimeSeriesRule
 */
export type AggregateTimeSeriesRule = Message<"chalk.aggregate.v1.AggregateTimeSeriesRule"> & {
  /**
   * @generated from field: string aggregation = 1;
   */
  aggregation: string;

  /**
   * @generated from field: google.protobuf.Duration bucket_duration = 2;
   */
  bucketDuration?: Duration;

  /**
   * The features which depend on this rule.
   *
   * @generated from field: repeated string dependent_features = 3;
   */
  dependentFeatures: string[];

  /**
   * @generated from field: google.protobuf.Duration retention = 4;
   */
  retention?: Duration;

  /**
   * @generated from field: string datetime_feature = 5;
   */
  datetimeFeature: string;

  /**
   * The tile-manifest materialization_key_hash this rule's lookups read.
   *
   * @generated from field: string materialization_key_hash = 6;
   */
  materializationKeyHash: string;
};

/**
 * Describes the message chalk.aggregate.v1.AggregateTimeSeriesRule.
 * Use `create(AggregateTimeSeriesRuleSchema)` to create a new message.
 */
export const AggregateTimeSeriesRuleSchema: GenMessage<AggregateTimeSeriesRule> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_timeseries, 0);

/**
 * @generated from message chalk.aggregate.v1.AggregateTimeSeries
 */
export type AggregateTimeSeries = Message<"chalk.aggregate.v1.AggregateTimeSeries"> & {
  /**
   * @generated from field: string namespace = 1;
   */
  namespace: string;

  /**
   * @generated from field: string aggregate_on = 2 [deprecated = true];
   * @deprecated
   */
  aggregateOn: string;

  /**
   * @generated from field: repeated string group_by = 3;
   */
  groupBy: string[];

  /**
   * @generated from field: repeated chalk.aggregate.v1.AggregateTimeSeriesRule rules = 5;
   */
  rules: AggregateTimeSeriesRule[];

  /**
   * @generated from field: string filters_description = 6;
   */
  filtersDescription: string;

  /**
   * @generated from field: string bucket_feature = 7;
   */
  bucketFeature: string;

  /**
   * @generated from field: repeated string aggregate_on_features = 8;
   */
  aggregateOnFeatures: string[];

  /**
   * Features the series' filters read, e.g. `transaction.status` in `_.status == "approved"`.
   *
   * @generated from field: repeated string filter_features = 9;
   */
  filterFeatures: string[];

  /**
   * Features read by projections in the aggregated column, e.g. `transaction.fx_rate` in `_.amount * _.fx_rate`.
   *
   * @generated from field: repeated string projection_features = 10;
   */
  projectionFeatures: string[];
};

/**
 * Describes the message chalk.aggregate.v1.AggregateTimeSeries.
 * Use `create(AggregateTimeSeriesSchema)` to create a new message.
 */
export const AggregateTimeSeriesSchema: GenMessage<AggregateTimeSeries> = /*@__PURE__*/
  messageDesc(file_chalk_aggregate_v1_timeseries, 1);

